import $ from 'jquery';

const loadingElem = $('#loading-bar');

export function activeLoading() {
	loadingElem.addClass('active');
}

export function deactivatesLoading() {
	loadingElem.removeClass('active');
}



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/loading-change.js
 **/